import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';


export const client = sanityClient({
    projectId: 'isk3vrra',
    dataset: 'production',
    apiVersion: '2022-06-28',
    useCdn: true,
    token: 'skNjpcyLAQRs63S5WQcUL1VNFwwf3PLVSBy2eFgaqgQfovAWufGlkA9lbP7fbo1IDCjagBJREMHci60BkhKaixsWF9IcRNQY2rbTr2mahioCiW8rgQ3vcyYeors7eht15u8r0gY1Tviq9tcs050LmqJFTz47LPdeIG1CI2KFGaubf8wsxviV',
    
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);